
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 7c5.017 0 9.544 2.083 12.813 5.406l-1.406 1.406c-2.905-2.961-6.94-4.813-11.406-4.813S7.5 10.85 4.595 13.812l-1.406-1.406C6.457 9.083 10.985 7 16.002 7zm0 5c3.639 0 6.919 1.521 9.281 3.938l-1.406 1.406C21.875 15.289 19.087 14 16 14s-5.875 1.288-7.875 3.344l-1.406-1.406C9.081 13.52 12.361 12 16 12zm0 5c2.26 0 4.295.956 5.75 2.469l-1.406 1.406C19.251 19.725 17.709 19 16 19s-3.25.725-4.344 1.875l-1.406-1.406C11.706 17.956 13.74 17 16 17zm0 5c.884 0 1.67.392 2.219 1L16 25.219 13.781 23c.549-.608 1.335-1 2.219-1z"}})])
          )
        }
      }
    